module.exports = __webpack_public_path__ + "img/120007.e59a8fde.png";